import ConfirmationModal from "components/modals/ConfirmationModal";

const RemoveCampaignModal = ({
  menuTrigger,
  campaignName,
  modelType,
  onConfirmDelete,
}) => (
  <ConfirmationModal
    actionDescription="Remove Campaign"
    buttonColor="red"
    onConfirm={onConfirmDelete}
    menuTrigger={menuTrigger}
    warning
  >
    <p>
      Are you sure you want to remove this {modelType} from{" "}
      <strong>{campaignName}</strong>?
    </p>
  </ConfirmationModal>
);

export { RemoveCampaignModal };
